export const fetcher = async (...props: Parameters<typeof fetch>) => {
  const result = await fetch(...props);
  return await result.json();
};
